<template>
  <div class="l_coupon">
    <div
      class="header"
      v-bind:style="{ 'padding-top': headerPaddingTop + 'px' }"
    >
      <div class="header_center">
        <img class="icon" src="@/assets/img/premium/icon.svg" />
      </div>
      <div class="header_end">
        <img src="@/assets/img/premium/close.svg" @click="__checkQuery()" />
      </div>
    </div>
    <div
      class="height_of_header"
      v-bind:style="{ 'padding-top': headerPaddingTop + 'px' }"
    >
      <div class="header_center"></div>
    </div>
    <div class="sub_title_wrapper">
      <img
        class="arrow_left"
        src="@/assets/img/premium/interlude_sub_title_arrow_left.png"
      />
      <p class="sub_title">プレミアムラウンジ会員専用のエリアです</p>
      <img
        class="arrow_right"
        src="@/assets/img/premium/interlude_sub_title_arrow_right.png"
      />
    </div>
    <div class="term">{{ limitDate }}</div>
    <router-link
      to="/faq/premium?showHeader=false"
      @click.native="
        () => {
          trapTrackEvent(1)
        }
      "
    >
      <div class="inner faq_icon">
        <img src="~@/assets/img/premium/faq.svg" />
      </div>
      <div class="inner faq" @click="tapFaqPremiumLounge()">
        <p class="tab">プレミアムラウンジって？</p>
      </div>
    </router-link>
    <!-- 絞り込みメニュー -->
    <TopMenu
      v-if="this.showTopMenu"
      :select="this.showItem"
      :freepass="this.existFreePass"
      @click="tapCondition"
    />
    <label
      for="foryou"
      class="foryou"
      v-if="this.isExistForYou && this.showItem === 'お知らせ'"
    >
      <input type="checkbox" id="foryou" v-model="checkForYou" />&nbsp;
      <span>「あなただけ」のお知らせのみ表示する</span>
    </label>

    <div v-show="!isNews() && !isTips()" class="container coupon">
      <coupon-with-cart-list
        v-if="canShowCoupon"
        :for-premium-lounge="true"
        :header-padding-top-for-premium-lounge="parseInt(headerPaddingTop)"
        @update-tabs="updateTopMenu"
      />
    </div>
    <div v-show="isNews()" class="container paddingtop">
      <div v-if="this.currentNewsList">
        <!-- 重要情報 -->
        <important-information
          v-for="(item, index) in this.currentNewsList"
          :key="index"
          :id="item.id"
          :title="item.caption"
          :url="item.url"
          :isImportant="item.kind"
          @click="
            () => tapAction(item.id, item.url, item.caption, infoImportant)
          "
        />
        <!-- News情報 -->
        <div class="l_contents">
          <news-panel
            v-for="(item, index) in this.currentNewsList"
            :key="index"
            :url="item.url"
            :image="item.thumb_url"
            :title="item.caption"
            :date="item.date"
            :category="item.category_id"
            :isImportant="item.kind"
            :youtubeId="item.youtube_id"
            :isPremium="true"
            @click="() => tapAction(item.id, item.url, item.caption, infoNews)"
          />
        </div>
      </div>
    </div>
    <div v-show="isTips()" class="container paddingtop">
      <div v-if="this.currentTipsList">
        <!-- 重要情報 -->
        <important-information
          v-for="(item, index) in this.currentTipsList"
          :key="index"
          :id="item.id"
          :title="item.caption"
          :url="item.url"
          :isImportant="item.kind"
          @click="
            () => tapAction(item.id, item.url, item.caption, infoImportant)
          "
        />
        <!-- 豆知識 -->
        <div class="l_contents">
          <news-panel
            v-for="(item, index) in this.currentTipsList"
            :key="index"
            :url="item.url"
            :image="item.thumb_url"
            :title="item.caption"
            :date="item.date"
            :category="item.category_id"
            :isImportant="item.kind"
            @click="() => tapAction(item.id, item.url, item.caption, infoNews)"
          />
        </div>
      </div>
    </div>
    <template v-if="this.isUseAlert">
      <alert-coupon
        :image="this.currentCoupon.thumb_url"
        :type="this.currentCoupon.type"
        :isFreepass="true"
        @useCoupon="tapAcceptUseCoupon"
        @cancelCoupon="tapCancelUseCoupon"
      />
    </template>

    <!-- Popup背景  -->
    <div
      class="l_popup__cover animation_background"
      v-if="this.popups.length > 0"
    ></div>

    <!-- Popupパネル -->
    <home-popup
      v-for="(item, index) in this.popUpsForDisplay"
      :key="`popup_${index}_${item.id}`"
      :id="item.id"
      :title="item.caption"
      :image="item.thumb_url"
      :isPopup="item.is_popup"
      @close="() => tapClose(item.id, item.caption)"
      @navigate="
        () => tapAction(item.id, item.url, item.caption, infoPopupDetail)
      "
    />

    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'もう一度試す'"
        @submit="() => tapRetryFetch()"
        @close="() => tapErrorClose()"
      />
    </template>
  </div>
</template>

<script>
import moment from 'moment'

import TopMenu from '@/components/PremiumTopMenu.vue'
import CouponCard from '@/components/PremiumCouponCard.vue'
import FreepassCard from '@/components/PremiumFreepassCard.vue'
import DateFormatter from '../utils/DateFormatter.js'

import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import AlertCoupon from '@/components/Modal/AlertCoupon'

import { mapActions, mapGetters } from 'vuex'
import { ErrorCode, ErrorMessage } from '@/api/APIClient'
import { FactoryTrack, ContentsType } from '../constant/firebase'
import ImportantInformation from '@/components/Home/ImportantInformation.vue'
import NewsPanel from '@/components/NewsPanel.vue'
import HomePopup from '@/components/Modal/HomePopup.vue'
import CouponWithCartList from '@/views/CouponWithCart/index.vue'
import { COUPON_TAB_TYPE } from '@/store/couponWithCart'

export default {
  name: 'Coupon',
  components: {
    CouponWithCartList,
    TopMenu,
    ErrorPopup,
    AlertCoupon,
    ImportantInformation,
    NewsPanel,
    HomePopup
  },
  data: function () {
    return {
      showItem: 'お知らせ',
      title: 'プレミアムラウンジ',
      apiType: '10',
      apiTypeFreepass: '7',
      apiTypeInfoList: '0',
      conditionQueryString: 'condition',
      condition: '2',
      currentCoupons: [],
      currentCoupon: null,
      isError: false,
      errorMessage: '',
      errorTitle: '',
      isUseAlert: false,
      infoNews: ContentsType.InfoNews,
      infoImportant: ContentsType.InfoImportant,
      infoPopupDetail: ContentsType.InfoPopupDetail,
      currentNewsList: [],
      currentTipsList: [],
      showTopMenu: false,
      existFreePass: false,
      headerPaddingTop: 10,
      headerHeight: 78,
      isExistForYou: false,
      checkForYou: false,
      isCouponExpire: 0,
      isFreePassExpire: 0,
      canShowCoupon: false
    }
  },
  computed: {
    ...mapGetters({
      coupons: 'Coupon/coupons',
      newsList: 'Home/allList',
      popups: 'Home/popups',
      stamp_year_start_at: 'User/stamp_year_start_at',
      selectedPremiumTab: 'PremiumTab/selectedPremiumTab'
    }),
    limitDate: function () {
      return this.stamp_year_start_at
        ? `${moment(this.stamp_year_start_at)
          .add(1, 'years')
          .format('YYYY/MM/DD')}まで入室可能`
        : '…'
    },
    popUpsForDisplay() {
      return this.popups.slice(0, 1)
    }
  },
  watch: {
    $route(to, from) {
      location.reload()
    },
    // popup表示している間はスクロール固定する、App.vueにisFixedが設定される
    popups: function (values) {
      const isFixed = values.length > 0
      document.body.className = isFixed ? 'scroll-lock' : ''
    },
    async conditionProp(val) {
      // update condition
      this.condition = this.conditionProp
    },
    newsList: function (val) {
      this.isExistForYou = val.some((item) => {
        return item.use_user_id === '1' && item.target_user_type !== '0'
      })
    },
    checkForYou: function (checked) {
      this.currentNewsList = this.newsList.filter((data) => {
        return (
          data.category_id !== '6' &&
          data.target_user_type !== '0' &&
          (checked ? data.use_user_id === '1' : true)
        )
      })
      console.log('current', this.currentNewsList)
    }
  },
  async created() {
    document.body.style.background = 'transparent'
    document.title = this.title // タイトル設定
    this.__checkQuertyCondition() // 条件取得
    const accTime = new DateFormatter().format(
      require('moment-timezone').tz('Asia/Tokyo')._d
    )
    try {
      window.receivedToken = async (payload) => {
        const json = JSON.parse(payload)
        await Promise.all([
          this.fetchInfoList(json.app_token, accTime, json.user_id),
          this.fetchUserData(json.app_token, accTime, json.user_id)
        ])
        window.receivedToken = null
        this.canShowCoupon = true
      }
      this.actionRequestToken({
        apiType: this.apiType,
        acc_time: accTime
      })
    } catch (e) {
      this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_TOKEN
      this.errorMessage = ErrorMessage.MSG_ERROR_TOKEN
      this.isError = true
      console.log(e)
    }

    this.getHeaderPaddingTop()
    this.actionHideHeader()

    // FIXME: for development
    // this.fetchInfoListFIXME'a', accTime, '89a1636f6b85c0d7')
    // this.fetchUserData('a', accTime, '89a1636f6b85c0d7')
    // this.getHeaderPaddingTop()
    // this.actionHideHeader()
  },
  mounted: function () {
    // 必ずページトップから始める
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 50)
    if (this.$route.query['coupon'] === '1') {
      this.showItem = 'クーポン'
    }
    if (this.selectedPremiumTab) {
      this.showItem = this.selectedPremiumTab
    }
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    ...mapActions('Native', [
      'actionCallCupon',
      'actionCallFreepass',
      'actionRequestToken',
      'asctionNavigateTo',
      'actionCallNewsDetail',
      'actionClosePremium',
      'actionShowHeader',
      'actionHideHeader',
      'actionRequestPaddingTop'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Coupon', [
      'actionFetchCoupon',
      'actionRequestExchangePrize'
    ]),
    ...mapActions('Home', [
      'action_FetchInfo',
      'action_SelectDetailNews',
      'action_DeletePopup'
    ]),
    ...mapActions('User', ['actionFetchUserData']),
    ...mapActions('PremiumTab', ['action_SetSelected']),
    ...mapActions('CouponWithCart', [
        'setSelectedTab',
      ]
    ),
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createFAQPremium())
          break
      }
    },
    tapAction(id, url, caption, type) {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoNews(id, caption, type))
      } catch (e) {
        console.log(e)
      }

      if (url !== '') {
        // external link
        this.navigateToRedirectDetail(id, url)
      } else {
        // internal link
        this.navigateToDetail(id, caption)
      }
    },
    tapFaqPremiumLounge() {
      this.actionShowHeader()
    },
    // URLがあれば、外部ページを詳細ページとして表示
    navigateToRedirectDetail(id, url) {
      this.actionToggleLoading(true)
      window.scrollTo(0, 0)
      this.updateLocalStorage(id)
      this.action_SelectDetailNews(id)
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 500)
      location.href = url
    },
    //  詳細ページへの遷移
    navigateToDetail(id, caption) {
      try {
        window.document.title = caption
        this.updateLocalStorage(id)
        this.action_SelectDetailNews(id)
        this.$router.push({
          name: 'HomeDetail'
        })
        this.actionShowHeader()
        // this.$router.push({ path: `/home/${id}` })
      } catch (e) {
        console.log(e)
      }
    },
    // クローズボタンを
    tapClose(id, caption) {
      this.trackEvent(FactoryTrack.createInfoPopupClose(id, caption))
      this.updateLocalStorage(id)
      this.action_DeletePopup(id)
    },
    // ローカルストレージデータの更新
    updateLocalStorage(id) {
      const key = 'news_' + id
      if (window.localStorage) {
        window.localStorage.setItem(key, 1)
      }
    },
    __checkQuery() {
      this.trackEvent(FactoryTrack.createClose('プレミアムラウンジ'))
      this.closePremium()
    },
    getHeaderPaddingTop() {
      // iPhone
      if (navigator.userAgent.indexOf('iPhone') > 0) {
        window.receivedTopPadding = (payload) => {
          const json = JSON.parse(payload)
          this.headerPaddingTop = json.paddingTop
        }
        this.actionRequestPaddingTop('premiumcoupon')
      }
    },
    closePremium() {
      this.actionClosePremium()
    },
    isFreePass(coupon) {
      return this.showItem === 'フリーパス' && coupon.data.prize_type !== '0'
    },
    isCoupon(coupon) {
      return this.showItem === 'クーポン' && coupon.data.prize_type === '0'
    },
    isNews() {
      return this.showItem === 'お知らせ'
    },
    isExistFreePass: function () {
      return this.currentCoupons.some((item) => item.data.prize_type !== '0')
    },
    isTips() {
      return this.showItem === '豆知識'
    },
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      this.action_ToggleModal(false)
      this.$router.go()
    },
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.action_ToggleModal(false)
      this.isError = false
    },
    /**
     * お知らせデータを取得
     * @param {String} token
     * @param {String} accTime
     * @param {String} userId
     */
    async fetchInfoList(token, accTime, userId) {
      this.actionToggleLoading(true)
      try {
        await this.action_FetchInfo({
          token: token,
          accTime: accTime,
          userId: userId
        })
        this.currentInfos = this.data
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.error(e)
      }
      // filter infolist with target_user_type to get premium infolist
      this.currentNewsList = this.newsList.filter(
        (data) => data.target_user_type !== '0' && data.category_id !== '6'
      )
      this.currentTipsList = this.newsList.filter(
        (data) => data.target_user_type !== '0' && data.category_id === '6'
      )
      this.actionToggleLoading(false)
    },

    // ユーザー情報を取得
    async fetchUserData(token, accTime, userId) {
      try {
        await this.actionFetchUserData({
          token: token,
          accTime: accTime,
          userId: userId
        })
      } catch (e) {
        console.log(e)
        if (this.errorType.length === 0) {
          this.errorType = 'user'
          this.errorMsg = e.message
          this.isError = true
        }
      }
      this.actionToggleLoading(false)
    },
    tapCondition(isSelect) {
      this.trackEvent(FactoryTrack.createCouponCondition(isSelect))
      this.action_SetSelected(isSelect)

      if (isSelect === 'クーポン') {
        this.setSelectedTab(COUPON_TAB_TYPE.coupon)
      } else if (isSelect === 'フリーパス') {
        this.setSelectedTab(COUPON_TAB_TYPE.freePass)
      }
      this.showItem = isSelect
    },
    /**
     * URLクエリパラメータを取得する
     */
    __checkQuertyCondition() {
      this.condition = this.$route.query[this.conditionQueryString]
    },
    updateTopMenu(tabs) {
      this.showTopMenu = true
      this.existFreePass = Object.keys(tabs).length > 1
    }
  }
}
</script>

<style lang="scss" scoped>
.paddingtop {
  padding-top: 16px;
}

.l_coupon:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100vh;
  background-image: url('~@/assets/img/premium/interlude_bg.png');
  background-size: 100%, auto;
  background-position: top;
}

.l_coupon > .container {
  text-align: left;
  margin-left: 14px;
  margin-right: 14px;

  padding-bottom: 40px;

  &.coupon {
    overflow: hidden;
    margin: 0;
  }
}
.foryou {
  color: #c0a417;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.sub_title_wrapper {
  height: 20px;
  display: flex;
  justify-content: center;
  margin: 10px 0;

  img {
    height: 100%;
  }

  .sub_title {
    color: #c0a417;
    font-size: 3.5vw;
    font-weight: bold;
  }

  .arrow_left {
    margin-right: 7px;
  }

  .arrow_right {
    margin-left: 7px;
  }
}

.term {
  color: #f2e7b4;
  font-weight: bold;
  background-image: url('~@/assets/img/premium/lounge_kigenwaku.png');
  background-size: contain;
  background-position: center;
  padding: 8px;
  margin: 10px;
  background-repeat: no-repeat;
  font-size: 4vw;
}

.faq {
  color: #c0a417;
  font-size: 11px;
  font-weight: bold;
  border: #c0a417;
  text-decoration: underline;
  text-decoration-color: #c0a417;
}

.faq_icon {
  margin-top: 4px;
  margin-right: 2px;
}

.icon {
  margin-left: 10px;
  margin-right: 10px;
}

.header {
  padding-bottom: 10px;
  border-bottom: solid 1px #c0a417;
  position: fixed;
  z-index: 1;
  background-image: url('~@/assets/img/premium/interlude_bg.png');
  background-size: 100%, auto;
  background-position: top;
}

.height_of_header {
  padding-bottom: 26px;
}

.header_start {
  height: auto;
  text-align: center;
  display: inline-block;
}

.header_center {
  width: 82%;
  height: auto;
  display: inline-block;
}

.text {
  width: 82%;
  height: auto;
}

.header_end {
  width: 14%;
  height: auto;
  display: inline-block;
}

.inner {
  display: inline-block;
  vertical-align: middle;
}
</style>
